import _ from 'lodash'
import { loading, blankResponseArray } from '../constants'
import { ResponseArray } from '../types'
import {
  ISalesRepFilter,
  ISalesRepFilterOn,
  ISalesRepSearchFilter,
  ISalesRepresentative,
  IAddress,
} from './types'

export const blankSalesRepArray: ResponseArray<ISalesRepresentative> = _.assign(
  [],
  blankResponseArray,
)

export const loadingSalesReps: ResponseArray<ISalesRepresentative> = _.assign(
  [],
  blankSalesRepArray,
  loading,
)
export const blankAddress: IAddress = {
  Name1: '',
  Street: '',
  Name2: '',
  City: '',
  Region: '',
  PostalCode: '',
  Phone: '',
  Country: 'US',
  Emails: [],
  FirstName: '',
  LastName: '',
}

export const blankSalesRep: ISalesRepresentative = {
  Id: '',
  Name: '',
  Address: blankAddress,
  PendingPermissionRequests: [],
  Permissions: [],
  Customers: [],
}

export const loadingSalesRep: ISalesRepresentative = _.assign(
  blankSalesRep,
  loading,
)

export const blankFilterOn: ISalesRepFilterOn = {
  Id: false,
  Name: false,
  PermissionRequests: false,
  Users: false,
}

export const blankFilter: ISalesRepFilter = {
  Id: '',
  Name: '',
  PermissionRequests: false,
  Users: false,
  City: '',
  State: '',
  PostalCode: '',
}

export const blankSearchFilters: ISalesRepSearchFilter =
{
  page: 1,
  sortBy: 'PermissionRequests',
  sortDesc: true,
  salesRepNumber: '',
  salesRepName: '',
  filterByHasUsers: false,
  filterByHasPendingPermissions: false,
  city: '',
  state: '',
  postalCode: '',
}
